import { IStore } from 'store/configureStore';
import { selectSubmittingOrgState } from 'modules/settings/submodules/clients/submittingOrg/store/selectors';

export const selectSubmittingOrgFilter = (state: IStore): string => {
    const submittingOrgState = selectSubmittingOrgState(state);
    return submittingOrgState.submittingOrgFilter;
};
